import { apiClient } from './client';
import type { Notification } from '@/types/models';
import type { BackendPaginatedResponse } from '@/types/api';

export interface UnreadCountResponse {
  unread_count: number;
}

export const notificationsApi = {
  getList: async (page = 1, limit = 20): Promise<BackendPaginatedResponse<Notification>> => {
    const response = await apiClient.get<BackendPaginatedResponse<Notification>>('/v1/my/notifications', {
      params: { page, limit },
    });
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await apiClient.get<UnreadCountResponse>('/v1/my/notifications/unread-count');
    return response.data.unread_count;
  },

  markRead: async (id: number): Promise<Notification> => {
    const response = await apiClient.patch<Notification>(`/v1/my/notifications/${id}/read`);
    return response.data;
  },
};
